<div class="login">
    <h1>An email has been sent</h1>
    <form id="ResetPasswordConfirmation" #resetPasswordForm="ngForm">
      <div class="form-group">
        <p>{{resetPasswordConfirmationText}}</p>
      </div>
      <div class="form-group text-right">
        <button type="submit" class="auth-submit"
                (click)="onReturnToLoginPage()" id="btnReturnToLogin">
          Return to Login Page
        </button>
      </div>
    </form>
  </div>
